import { useTranslations } from 'next-intl';
import { useRouter } from 'next/router';

interface ILogoProps {
  locale?: 'fr' | 'de';
  alt?: string;
  width?: number;
  height?: number;
}

export const Logo = ({
  locale: localeFromProps,
  alt,
  width,
  height,
}: ILogoProps) => {
  const tGlobal = useTranslations('Global');
  const { locale: localeFromRouter } = useRouter();

  const locale = localeFromProps || localeFromRouter || 'fr';

  return (
    <img
      src={`/icons/brand_logos/${locale}.svg`}
      alt={alt || tGlobal('companyName')}
      className="tw-align-bottom"
      width={width}
      height={height}
    />
  );
};
